import gql from "graphql-tag";

export const SCREEN_FIELDS = `{
    id_pantalla
    nombre_pantalla
    descripcion_pantalla
    codigo
    ubicacion
    latitud
    longitud
    zona_horaria
    activado
    fecha_conexion
    canales {
      id_canal
      nombre_canal
      hora_inicio_pt
      hora_fin_pt
      orden
      descripcion_canal
      reproduccion_dia
      reproduccion_hora
      cantidad_pantallas
      fecha_creacion
      fecha_modificacion
      estado {
        id_estado
        nombre_estado
      }
    }
    dispositivo {
      id_dispositivo
      codigo
      tipo_dispositivo
      nombre_dispositivo
      version_app
    }
    frecuencia
    estado {
      id_estado
      nombre_estado
      color
      id_estado_real
    }
    db_message
  }`

export const GET_SCREEN = gql`
  query GetPantallaOneUpdated($id_pantalla: Int!) {
    GetPantallaOneUpdated(id_pantalla: $id_pantalla) ${SCREEN_FIELDS}
  }
`;

export const GET_PANTALLAS_PAGINADAS = gql`
  query PantallasPaginadasUpdated($idPantalla: [Int]!) {
    PantallasPaginadasUpdated(id_pantalla: $idPantalla) {
      id_pantalla
      fecha_conexion
      nombre_pantalla
      codigo
      ubicacion
      estado {
        id_estado
        nombre_estado
      }
      canales {
        nombre_canal
        id_canal
        cantidad_pantallas
        estado {
          id_estado
          nombre_estado
          color
        }
        frecuencia {
          id_frecuencia
        }
        lista_reproduccion {
          id_lista
          url_logo
          videos {
            id_file
            archivo {
              id_archivo
              url_archivo
              detalle_tipoa {
                id_detalle
                tipo_archivo {
                  id_tipo
                  nombre_archivo
                }
              }
            }
          }
          banners {
            id_file
            archivo {
              id_archivo
              url_archivo
              detalle_tipoa {
                id_detalle
                tipo_archivo {
                  id_tipo
                  nombre_archivo
                }
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_LIST_SCREENS = gql`
query GetPantallaListUpdated {
  GetPantallaListUpdated {
    id_pantalla
    nombre_pantalla
    descripcion_pantalla
    codigo
    ubicacion
    zona_horaria
    activado
    fecha_conexion
    canales {
      id_canal
      nombre_canal
      hora_inicio_pt
      hora_fin_pt
      orden
      descripcion_canal
      reproduccion_dia
      reproduccion_hora
      cantidad_pantallas
      fecha_creacion
      fecha_modificacion
    }
    estado {
      id_estado
      nombre_estado
      color
      id_estado_real
    }
    db_message
    dispositivo {
      id_dispositivo
      tipo_dispositivo
      version_actual
      version_app
    }
  }
}
`;